import { useState } from 'react'
import { Container, Tabs, Tab } from 'react-bootstrap'
import { useAuth } from '../../hooks/useAuth'
import InvoicesList from '../../components/Financial/InvoicesList'
import BillsList from '../../components/Financial/BillsList'
import PaymentsList from '../../components/Financial/PaymentsList'
import FinancialTransactionsList from '../../components/Financial/FinancialTransactionsList'
import BankReconciliation from '../../components/Financial/BankReconciliation'
import CollectionsDashboard from '../../components/Financial/CollectionsDashboard'
import PACConfigurations from '../../components/Financial/PACConfigurations'
import PACGlobalConfigurations from '../../components/Financial/PACGlobalConfigurations'
import LoginCampaignsAdmin from '../../components/Financial/LoginCampaignsAdmin'
import BillingConfigurations from '../../components/Financial/BillingConfigurations'
import BankAccounts from '../../components/Financial/BankAccounts'
import BankFormats from '../../components/Financial/BankFormats'
import SaldosAFavorPanel from '../../components/Financial/SaldosAFavorPanel'
import RecurringInvoices from '../../components/Financial/RecurringInvoices'
import { useQuery } from 'react-query'
import api from '../../services/api'
import { tieneModulo } from '../../utils/modulos'
import './Financial.css'

const Financial = () => {
  const { user } = useAuth()
  // La pestaña inicial tiene que ser una que el plan incluya: arrancar en una escondida
  // deja la página en blanco sin decir por qué.
  const [activeTab, setActiveTab] = useState(
    () => (tieneModulo(user, 'facturacion') ? 'invoices'
          : tieneModulo(user, 'bancos') ? 'reconciliation'
          : tieneModulo(user, 'cobranza') ? 'collections' : 'invoices'))
  // Igual que el backend (EsSuperAdminPAC): el rol cuenta, no sólo `is_superuser`.
  const isSuperAdmin = !!(user?.is_superuser || user?.role === 'superadmin')
  const isAdmin = isSuperAdmin || ['admin', 'superadmin'].includes(user?.role)
  const { data: clients } = useQuery(
    'clients-financial-tabs',
    async () => {
      const response = await api.get('/clients/clients/?activo=true')
      return response.data.results || response.data || []
    },
    { enabled: !!user }
  )

  return (
    <Container fluid className="financial-page">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Módulo Financiero</h1>
      </div>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="invoices" title="Facturas">
            <InvoicesList />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="recurrentes" title="Recurrentes">
            <RecurringInvoices />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="bills" title="Facturas Recibidas">
            <BillsList />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="payments" title="Pagos">
            <PaymentsList />
          </Tab>
        )}
        {tieneModulo(user, 'bancos') && (
          <Tab eventKey="financial-transactions" title="Transacciones Financieras">
            <FinancialTransactionsList />
          </Tab>
        )}
        {tieneModulo(user, 'bancos') && (
          <Tab eventKey="reconciliation" title="Conciliación Bancaria">
            <BankReconciliation />
          </Tab>
        )}
        {tieneModulo(user, 'cobranza') && (
          <Tab eventKey="collections" title="Cobranza">
            <CollectionsDashboard />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="saldos-nc" title="Saldos a favor / NC">
            <SaldosAFavorPanel clients={clients || []} />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          <Tab eventKey="billing-config" title="Configuración de Facturación">
            <BillingConfigurations />
          </Tab>
        )}
        {tieneModulo(user, 'facturacion') && (
          // Regla de negocio: sólo el superadmin configura el PAC (cuenta de Multifacturas); el
          // contador aquí sólo carga el CSD de sus contribuyentes.
          <Tab eventKey="pac-config" title={isSuperAdmin ? 'Configuración PAC' : 'Certificados CSD'}>
            <PACConfigurations />
          </Tab>
        )}
        {isSuperAdmin && (
          <Tab eventKey="pac-global-config" title="Configuración PAC Global (Admin)">
            <PACGlobalConfigurations />
          </Tab>
        )}
        {isAdmin && (
          <Tab eventKey="login-campaigns" title="Campañas Login (Admin)">
            <LoginCampaignsAdmin />
          </Tab>
        )}
        {tieneModulo(user, 'bancos') && (
          <Tab eventKey="bank-accounts" title="Cuentas Bancarias">
            <BankAccounts />
          </Tab>
        )}
        {tieneModulo(user, 'bancos') && (
          <Tab eventKey="bank-formats" title="Formatos Bancarios">
            <BankFormats />
          </Tab>
        )}
      </Tabs>
    </Container>
  )
}

export default Financial
